import { referralsTexts } from '../referrals.texts'
import type { ReferralUsageStatus } from '../referrals.types'

interface UsageStatusBadgeProps {
  status: ReferralUsageStatus
}

const STATUS_BADGE_CLASS: Record<ReferralUsageStatus, string> = {
  ACTIVE: 'bg-toast-success text-toast-success-text',
  SUSPENDED: 'bg-toast-warning text-toast-warning-text',
  CANCELLED: 'bg-background-secondary text-muted',
  EXPIRED: 'bg-background-secondary text-muted',
}

export const UsageStatusBadge = ({ status }: UsageStatusBadgeProps) => (
  <span
    className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${STATUS_BADGE_CLASS[status]}`}
  >
    {referralsTexts.usages.status[status]}
  </span>
)
